import React, { Fragment, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { clearErrorAction,createAdsAction } from '../redux/actions/productAdsActions'
import swal from 'sweetalert';
import { Button } from '@material-ui/core'
import Loader from '../layout/loader';
import DescriptionIcon from '@material-ui/icons/Description';
import SpellCheckIcon from '@material-ui/icons/Spellcheck'
import Filter6Icon from '@mui/icons-material/Filter6';

import Sidebar from './Sidebar'
import './createNewProduct.css'
import { CREATE_PRODUCT_HEADING_RESET } from '../redux/constants/productAdsConstants';

function CreateAdsAdmin() {

    const dispatch = useDispatch();
    const history = useHistory();
    const { loading, error, success } = useSelector((state) => state.productAdsCreate)
    const [name, setName] = useState('');
    const [tag, setTag] = useState('');
    const [descriptions, setDescriptions] = useState('');
    const [image, setImage] = useState('');

    useEffect(() => {
        if (error) {
            swal({
                title: "Validation",
                text: error,
                icon: "error",
              })
            dispatch(clearErrorAction())
        }
        if (success) {
            swal({
                title: "Created.",
                text: success,
                icon: "success",
              })
            history.push('/Admin/dashboard')
            dispatch({ type: CREATE_PRODUCT_HEADING_RESET })
        }

    }, [ dispatch, error, history, success])

    // on click function when submit button press
    const createProductSubmitHandler = async (e) => {
        e.preventDefault()


        let formData = new FormData();
        formData.append('name', name);
        formData.append('descriptions', descriptions);
        formData.append('tag', tag);



        for (let index = 0; index < image.length; index++) {
            formData.append('image', image[index]);
        }


        dispatch(createAdsAction(formData));

    }



    // // for images adding function


    const createAdsImageChange = (e) => {

        setImage(e.target.files);
    }


  return (
    <Fragment>
         <div className="dashboard-container">
                <Sidebar />
                {loading ? <Loader /> : (<Fragment>
                    <div className="newProductContainer">
                        <form className='createProductForm createAdsForm'
                            onSubmit={createProductSubmitHandler}  >
                            <div className="create-product-hero create-ads-hero">
                                <div>
                                    <span>Storefront promotion</span>
                                    <h1>Create Product Ads</h1>
                                    <p>Prepare promotional banners and featured ad cards for the shopping pages.</p>
                                </div>
                                <div className="create-product-progress">
                                    <strong>{image?.length || 0}</strong>
                                    <span>ad images selected</span>
                                </div>
                            </div>

                            <section className="create-product-section">
                                <div className="create-product-section-head">
                                    <span>01</span>
                                    <div>
                                        <h2>Ad Details</h2>
                                        <p>Write a clear ad title, tag, and short promotional description.</p>
                                    </div>
                                </div>
                                <div className="create-product-grid">
                                    <label className="create-product-field">
                                        <span>Product / campaign name</span>
                                        <div>
                                            <SpellCheckIcon />
                                            <input
                                                type='text'
                                                placeholder='Summer sneaker drop'
                                                required
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                    </label>

                                    <label className="create-product-field">
                                        <span>Ad tag</span>
                                        <div>
                                            <Filter6Icon />
                                            <input
                                                type='text'
                                                placeholder='Featured, Sale, New launch'
                                                required
                                                value={tag}
                                                onChange={(e) => setTag(e.target.value)}
                                            />
                                        </div>
                                    </label>

                                    <label className="create-product-field create-product-wide">
                                        <span>Description</span>
                                        <div>
                                            <DescriptionIcon />
                                            <textarea
                                                placeholder='Add a short message customers will understand quickly...'
                                                required
                                                value={descriptions}
                                                onChange={(e) => setDescriptions(e.target.value)}
                                                cols={10}
                                                rows={1}
                                            ></textarea>
                                        </div>
                                    </label>
                                </div>
                            </section>

                            <section className="create-product-section">
                                <div className="create-product-section-head">
                                    <span>02</span>
                                    <div>
                                        <h2>Ad Images</h2>
                                        <p>Upload clean, wide images that can work inside homepage and product promotions.</p>
                                    </div>
                                </div>
                                <label className="create-product-upload create-ads-upload" id="createProductFormFile">
                                    <strong>Promotion artwork</strong>
                                    <span>Choose one or more images for this ad campaign.</span>
                                    <input type="file"
                                        name='image'
                                        accept='image/*'
                                        multiple
                                        onChange={createAdsImageChange}
                                    />
                                    <em>{image?.length || 0} images selected</em>
                                </label>
                            </section>
                            {/* <div id="createProductFormFileImage">
                            {imagePreview.map((image, index) => (
                                <img key={index} src={image} alt="images" />
                            ))}


                        </div> */}

                            <div className="create-product-submit-row">
                                <Button
                                    id='createProductBtn'
                                    type='submit'
                                    disabled={loading ? true : false}

                                >
                                    Create Ads
                                </Button>
                            </div>


                        </form>
                    </div>




                </Fragment>)}
            </div>

    </Fragment>
    
  )
}

export default CreateAdsAdmin
